import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/index.css";
import App from "@/App";
import AdminApp from "@/pages/AdminApp";
import LandingPage from "@/pages/LandingPage";
import StickerRequestPage from "@/pages/StickerRequestPage";
import { I18nProvider } from "@/lib/i18n";
import { QrProvider } from "@/lib/qrContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <React.StrictMode>
        <I18nProvider>
            <QrProvider>
                <BrowserRouter>
                    <Routes>
                        <Route path="/admin" element={<AdminApp />} />
                        <Route path="/landing" element={<LandingPage />} />
                        <Route
                            path="/anforderung"
                            element={<StickerRequestPage />}
                        />
                        <Route path="*" element={<App />} />
                    </Routes>
                </BrowserRouter>
            </QrProvider>
        </I18nProvider>
    </React.StrictMode>,
);
